<template>
  <v-menu bottom left offset-y>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mdi-apps</v-icon>
      </v-btn>
    </template>

    <v-card class="text-center">
      <div class="pa-3">
        <v-row no-gutters>
          <v-col cols="6">
            <v-btn class="app-btn" text href="https://fleet.usail.es">
              <div>
                <div class="app-icon mb-1">
                  <img src="https://file.usail.es/static/fleet-commander-icon-white.svg" />
                </div>
                <span class="caption">Fleet</span>
              </div>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn class="app-btn" text href="https://connect.usail.es">
              <div>
                <div class="app-icon mb-1">
                  <img style="margin-top: -3px" src="https://file.usail.es/static/connect-icon-white.svg" />
                </div>
                <span class="caption">Connect</span>
              </div>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'ToolbarApps'
}
</script>

<style lang="scss" scoped>
.app-btn {
  margin: 0;
  width: 80px;
  height: 110px !important;
  img {
    height: 40px;
  }
}

.app-icon {
  background-color: #2196f3;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 32px;
  }
}
</style>
